import React from 'react';
import {IoReorderFourSharp} from 'react-icons/io5';

export function OtherIcon({...rest}) {
  return <IoReorderFourSharp size={35} {...rest} />;
}
